/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_TilInputs */

const en_node_til = /** @type {(inputs: Node_TilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIL`)
};

/**
* | output |
* | --- |
* | "TIL" |
*
* @param {Node_TilInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_til = /** @type {((inputs?: Node_TilInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_TilInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_til(inputs)
});